module.exports = __webpack_public_path__ + "img/wechat.d0a3b1e4.jpeg";